//var navbar;
var navbarHeight;
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var width = $(window).width() +15; // (+15?)
//console.log(width);

$(document).on('ready', function() {
  //navbar = document.getElementById("collapsingHeader");
  navbarHeight = 50;
  //console.log(navbar);
  //console.log(navbarHeight);
  //console.log("start");
});

// on scroll, let the interval function know the user has scrolled
$(window).on('scroll', function(){
  //console.log("scrolled");
  didScroll = true;
});

// Hide header menu when navbar is hidden with .nav-hide
document.addEventListener('transitionend', function() {
  var hided = $('#collapsingHeader');
  if($(hided).hasClass('nav-hide')) {
    $(hided).find('.upper-menu').css('display', 'none');
  }
}, false);

// run hasScrolled() and reset didScroll status
setInterval(function() {
  if (didScroll && width >= 992) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  var st = $(this).scrollTop();

 if (Math.abs(lastScrollTop - st) <= delta){
    return;
  }

    // If current position > last position AND scrolled past navbar...
  if (st > lastScrollTop && st > navbarHeight){
    // Scroll Down
    //console.log("hide");
    $("#collapsingHeader").addClass("nav-hide");
  } else {
    // Scroll Up
    // If did not scroll past the document (possible on mac)...
    if(st + $(window).height() < $(document).height()) {
      var hided = $("#collapsingHeader");
      $(hided).removeClass("nav-hide");
      //remove display none from header menu
      $(hided).find('.upper-menu').css('display', '')
    }
  }

  lastScrollTop = st;
}

$('.nav-search-btn').on('click', function() {
  toggleShopSearchField();
});

$('.searchBackground').on('click', function() {
  toggleShopSearchField();
});

function toggleShopSearchField() {
  $('.nav-search').toggle();
  $('.menu-bottommenu-ammattilaisille-container').toggle();
  $('.nav-link-shop').toggle();
  $('.nav-link-button').toggle();
  $('.nav-search-btn .showSearch').toggle();
  $('.nav-search-btn .closeSearch').toggle();
  $('.searchBackground').toggle();
}

function add_item_span() {
  //console.log("add_item_span");
  $(".nav-professional-mobile-container li.menu-item-has-children").each(function() {
    $(this).append('<span class="extract"></span>');
  });
}

function expand() {
  //console.log("expand");
  $(".nav-professional-mobile-container li.menu-item-has-children span.extract").on(
    "click",
    function() {

      var parentid = $(this).closest('li');
      parentid.toggleClass('expanded');
      //($(this).closest('li').attr('class'));
      parentid.find('.sub-menu').slideToggle( "fast", function() {
        // Animation complete.
      });

    }
  );
}

add_item_span();
expand();





// WEBPACK FOOTER //
// ./scripts/header.js